import React from "react";
import PropTypes from "prop-types";

const ArrowTopRight = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 31.11 29.86">
      <g id="Layer_5" data-name="Layer 5">
        <path d="M0,28.58a10,10,0,0,0,2.53.34,10,10,0,0,0,10-10V17.57a10.91,10.91,0,0,1,10.9-10.9h4.53l1.31,0A13.5,13.5,0,0,1,24.05.77l0-.1L24.68,0l.09.2A12.06,12.06,0,0,0,31,6.66l.05,0,0,0v.87h0l0,0-.15.07a12.13,12.13,0,0,0-6.2,6.5l-.09.2L24,13.69l0-.1a13.37,13.37,0,0,1,5.15-6l-1.25,0H23.39a10,10,0,0,0-10,10V19a10.91,10.91,0,0,1-10.9,10.9A11.09,11.09,0,0,1,0,29.55Z" />
      </g>
    </svg>
  );
};

ArrowTopRight.defaultProps = {
  className: ``
};

ArrowTopRight.propTypes = {
  className: PropTypes.string
};

export default ArrowTopRight;
